import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, reset} from 'redux-form';
import {Button, Form} from 'semantic-ui-react';
import {useToasts} from 'react-toast-notifications';
import FormSelect from '../shared/forms/select';
import FormDatePicker from '../shared/forms/datepicker';
import FormInput from '../shared/forms/input';
import FormTextArea from '../shared/forms/textarea';
import {createExamReport} from '../../redux/actions/exam-report';
import {convertDatetimeToObject} from '../shared/forms/utils';
import {required} from '../shared/forms/validations';

function ExamReportForm(props) {
  const {studentCourseOptions, disabledDays, handleSubmit, submitting} = props;

  const {addToast} = useToasts();
  const successMessage = 'گزارش آزمون شما با موفقیت ثبت گردید.';

  return (
    <Form onSubmit={handleSubmit(submit.bind(null, props, addToast, successMessage))}>
      <Form.Group widths='equal'>
        <Field
          required
          name='studentCourse'
          label='آزمون'
          component={FormSelect}
          options={studentCourseOptions}
          validate={required}
        />
        <Field
          required
          name='date'
          label='تاریخ آزمون'
          validate={required}
          component={FormDatePicker}
          maximumDate={convertDatetimeToObject()}
          disabledDays={disabledDays}
        />
        <Field
          required
          name='result'
          label='نتیجه آزمون'
          validate={required}
          component={FormInput}
          type='number'
        />
      </Form.Group>

      <Field
        name='description'
        label='توضیحات'
        component={FormTextArea}
      />
      <Button type='submit' disabled={submitting} content='ارسال'/>
    </Form>
  );
}

async function submit(props, addToast, successMessage, values) {
  try {
    await props.createExamReport(values);
    await props.reset();
    addToast(successMessage, {appearance: 'success'});
  } catch (e) {
    addToast(e.response.data['non_field_errors'], {appearance: 'error'});
  }
}

function mapStateToProps(_, {remainStudentCourses}) {
  const studentCourseOptions = remainStudentCourses.map(
    studentCourse => ({key: studentCourse.id, value: studentCourse.id, text: studentCourse.name})
  );
  const initialValues = {result: '50.0'};
  return {studentCourseOptions, initialValues};
}

ExamReportForm.defaultProps = {homeworks: [], latestReports: []};

export default compose(
  connect(mapStateToProps, {createExamReport, reset}),
  reduxForm({form: 'report'})
)(ExamReportForm);
